export default __webpack_public_path__ + "static/Plots0002-81873a447de16157a09319a1e4bb9330.jpg";